import Button from "../../components/Button";
import { useEffect, useMemo, useState } from "react";
import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { Step } from "../../components/Step";
import SetTemperature from "../../components/SetTemperature";
import SetTime from "../../components/SetTime";
import MessageModal, { MessageModalProps } from "../../components/MessageModal";
import TemperatureDisplay from "../../components/TemperatureDisplay";
import TemperatureChart from "../../components/TemperatureChart";
import InputModal, { InputModalProps } from "../../components/InputModal";
import { cToF } from "../../utils";
import { getRouterPath } from "../../utils/route";
import { useNavigate } from "react-router-dom";

let runProgramTimeout: any
function QuickStart() {
  const { dataStore } = useStore();
  const resData = dataStore.resData;
  const navigate = useNavigate()
  // console.log('resData', toJS(resData))
  const [saveLogModal, setSaveLogModal] = useState<InputModalProps>({
    isOpen: false,
    title: "Save log as:",
    value: "New",
    onSave: (value: string) => {
      setSaveLogModal((data) => ({ ...data, isOpen: false }));
    },
    onCancel: () => {
      setSaveLogModal((data) => ({ ...data, isOpen: false }));
    },
  });

  const [saveProgramModal, setSaveProgramModal] = useState<InputModalProps>({
    isOpen: false,
    title: "Save program as:",
    value: "New",
    onSave: (value: string) => {

      dataStore.setNav({ title: 'Easy Ferment' })

    },
    onCancel: () => {
      dataStore.setNav({ title: 'Easy Ferment' })
      setSaveProgramModal((data) => ({ ...data, isOpen: false }));
    },
  });

  const [messageModal, setMessageModal] = useState<MessageModalProps>({
    isOpen: false,
    buttons: [],
    title: "",
  });

  let activeLogData = resData.activeLogAck;
  const defaultData = resData.defaultAck;
  const runProgramProgressAck = resData.runProgramProgressAck;


  const steps = (
    activeLogData?.state === "DRAFT"
      ? activeLogData?.draftProgram?.steps ||
      activeLogData?.activeProgram?.steps ||
      []
      : activeLogData?.state === "ACTIVE" || activeLogData?.state === "FINISHED"
        ? activeLogData?.activeProgram?.steps || []
        : activeLogData?.draftProgram?.steps ||
        activeLogData?.activeProgram?.steps ||
        []
  ).map((step, index) => ({ ...step, ...runProgramProgressAck?.steps[index] }));

  const programName = activeLogData?.activeProgram?.name || "New";

  //当前Step Index
  const [stepIndex, setStepIndex] = useState<number>(0);

  // 当前编辑的step
  const editStep = (steps && steps[stepIndex]) || defaultData?.step;

  function swapStep(currentStep: number, targetStep: number) {
    dataStore.sendData({
      action: "swapStep",
      data: {
        currentStep, // 当前步骤位置
        targetStep, // 目标步骤位置，即将移动到的新位置
      },
    });
  }

  const runProgram = (ms?: number) => {
    runProgramTimeout && clearTimeout(runProgramTimeout)
    runProgramTimeout = setTimeout(() => {
      dataStore.sendData({
        action: "runProgram",
        data: {},
      });
    }, ms || 100);

  };


  function openSaveProgram() {
    dataStore.setNav({ title: 'Saving Program' })
    setSaveProgramModal((data) => ({
      ...data,
      title: "Save program as:",
      isOpen: true,
      value: programName,
      onSave: async (value) => {
        await saveProgram(value);
        dataStore.setNav({ title: 'Easy Ferment' })
        setSaveProgramModal((data) => ({ ...data, isOpen: false }));
      },
    }));
  }



  function saveProgram(name: string): Promise<'YES' | 'NO'> {

    return new Promise((resolve, reject) => {

      if (resData.loadProgramAck?.programs.some(item => item.name === name)) {
        setMessageModal({
          isOpen: true,
          buttons: [
            {
              text: "YES",
              onAction: () => {

                dataStore.sendData({
                  action: "saveProgram",
                  data: {
                    name: name,
                  },
                });
                setMessageModal({ ...messageModal, isOpen: false });

                resolve('YES')

              },
              style: {
                backgroundColor: '#5ede4e',
              }
            },
            {
              text: "NO",
              onAction: () => {
                setMessageModal({ ...messageModal, isOpen: false });
                resolve('NO')
              },
            },
          ],
          title: "Overwrite Program?",
        });

      } else {

        dataStore.sendData({
          action: "saveProgram",
          data: {
            name,
          },
        });
        resolve('YES')

      }
    })




  }

  const editProgram = () => {
    dataStore.sendData({
      action: "editProgram",
      data: {},
    });
  };

  const cancelEditProgram = () => {
    dataStore.sendData({
      action: "cancelEditProgram",
      data: {},
    });
  };

  const stopProgram = () => {
    dataStore.sendData({
      action: "stopProgram",
      data: {},
    });
  };


  const exitProgram = () => {
    dataStore.sendData({
      action: "exitProgram",
      data: {},
    });
  }

  const saveUserLog = (logId: string, logName: string) => {
    dataStore.sendData({
      action: "saveUserLog",
      data: {
        logId,
        logName,
        type: 'auto'
      },
    });
  };

  // 创建新的step
  function addStep() {
    let newStep = {
      ...defaultData?.step,
    };

    dataStore.sendData({
      action: "saveStep",
      data: {
        ...newStep,
      },
    });

    setStepIndex(steps.length);

  }

  // 删除step
  function deleteStep(index: number) {
    setMessageModal({
      isOpen: true,
      buttons: [
        {
          text: "YES",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
            dataStore.sendData({
              action: "deleteStep",
              data: {
                step: index,
              },
            });

            setStepIndex(steps.length - 2);

          },
          style: {
            backgroundColor: '#5ede4e',
          }
        },
        {
          text: "NO",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
          },
        },
      ],
      title: "Delete this step?",
    });
  }

  function onTouchTemperature(e: number) {
    dataStore.sendData({
      action: "updateStep",
      data: {
        step: stepIndex + 1,
        temperature: e,
      },
    });
  }

  // 更新当前日期
  function onChangePicker(type: string, value: number) {
    dataStore.sendData({
      action: "updateStep",
      data: {
        step: stepIndex + 1,
        [type]: value,
      },
    });
  }

  /**
   * 是否零时长
   */
  const isZeroTimeStep = steps.some(
    (step) => step.day === 0 && step.hour === 0 && step.minutes === 0
  );

  const selectZeroTimeStepIfExists = () => {
    const index = steps.findIndex(
      (step) => step.day === 0 && step.hour === 0 && step.minutes === 0
    );
    setStepIndex(index);
  };




  useEffect(() => {

    switch (resData.activeLogAck?.state) {
      case 'DRAFT':
        {
          //回到 RAFT 当 stepIndex 失焦就改为0
          if (steps.findIndex((item, index) => index === stepIndex) === -1) {
            setStepIndex(0)
          }
        }
        break;
    }

  }, [resData.activeLogAck?.state])



  useEffect(() => {

    dataStore.sendData({ action: 'loadProgram', data: {} })

  }, [])

  //初始化表格记录
  const records = { data: resData.runProgramRecordChartAck?.data || [] }

  if (resData.loadSettingAck?.temperatureUnit === 'F') {
    records.data = records?.data?.map(item => ({ ...item, temperature: Number(cToF(item.temperature)) }))
  }

  const temperatureChartProps = useMemo(
    () => {
      return {
        unit: resData.loadSettingAck?.temperatureUnit,
        dateFormat: resData.loadSettingAck?.dateFormat,
        temperature: records.data
          .map(item => {
            let targetData: number | undefined
            if (resData.activeLogAck?.activeProgram?.steps.length && typeof (item.step) === 'number') {
              const stepData = resData.activeLogAck?.activeProgram?.steps[item.step]


              targetData = resData.loadSettingAck?.temperatureUnit === 'F' ? Number(cToF(stepData.temperature)) : stepData.temperature
            }

            return { data: item.temperature, time: item.time, targetData }
          }),
        humidity: records.data.map(item => {
          return {
            data: item.humidity, time: item.time
          }
        }),
        XAxisTickFormatterTimeFormat: 'DD HH:mm',
        styleTemperature: {
          width: "100%",
          height: resData.loadSettingAck?.humidityEnabled ? 160 : 340,
          marginTop: 30,
        },
        styleHumidity: {
          width: "100%",
          height: 140,
          marginTop: 30,
        },
      }
    },
    [resData.activeLogAck, records.data, resData.loadSettingAck?.dateFormat, resData.loadSettingAck?.temperatureUnit, resData.loadSettingAck?.humidityEnabled]
  );



  return (
    <div className="flex">
      <div className="w-[1280px] h-[730px] flex">
        <div
          className="flex"
          style={{
            flex: 1,
          }}
        >
          {/* 左侧 */}
          <Step
            resData={resData}
            state={activeLogData?.state || "DRAFT"}
            style={{
              marginLeft: 15,
              alignSelf: "center",
            }}
            title={programName}
            steps={steps}
            onDeleteStep={deleteStep}
            onOpenSaveProgram={openSaveProgram}
            onSaveStep={addStep}
            onSelectStepIndex={(index) => setStepIndex(index)}
            selectStepIndex={stepIndex}
            onSwapStep={swapStep}
            onRunAgain={runProgram}
            onEdit={editProgram}
          />

          {/* 右侧 */}
          <div
            className="flex"
            style={{
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: 50,
              paddingTop: 50,
            }}
          >
            {(() => {
              switch (activeLogData?.state) {
                case "DRAFT": {
                  return (
                    <div>
                      <SetTemperature
                        unit={resData.loadSettingAck?.temperatureUnit as any}
                        value={editStep?.temperature || -18}
                        // onChange={(e) => onChangeTemperature(e)}
                        onTouchEnd={(e) => onTouchTemperature(e)}
                        rangeData={defaultData?.stepTemperatureRange}
                      />

                      {/* 下方 1*/}
                      <SetTime
                        style={{
                          marginTop: 40,
                        }}
                        pickers={[
                          {
                            type: "day",
                            onChangePicker: (value) =>
                              onChangePicker("day", value),
                            value: editStep?.day?.toString() || "0",
                            isInf: stepIndex === steps?.length - 1,
                          },
                          {
                            type: "hour",
                            onChangePicker: (value) =>
                              onChangePicker("hour", value),
                            value: editStep?.hour?.toString() || "0",
                            disabled: editStep.day === -1,
                          },
                          {
                            type: "minutes",
                            onChangePicker: (value) =>
                              onChangePicker("minutes", value),
                            value: editStep?.minutes?.toString() || "0",
                            disabled: editStep.day === -1,
                          },
                        ]}
                      />
                    </div>
                  );
                }

                case "EDITING": {
                  return (
                    <div>
                      <SetTemperature
                        unit={resData.loadSettingAck?.temperatureUnit as any}
                        value={editStep?.temperature || -18}
                        // onChange={(e) => onChangeTemperature(e)}
                        onTouchEnd={(e) => onTouchTemperature(e)}
                        rangeData={defaultData?.stepTemperatureRange}
                      />
                      {!editStep.currentTime && (
                        <SetTime
                          style={{
                            marginTop: 40,
                          }}
                          pickers={[
                            {
                              type: "day",
                              onChangePicker: (value) =>
                                onChangePicker("day", value),
                              value: editStep?.day?.toString() || "0",
                              isInf: stepIndex === steps?.length - 1,
                            },
                            {
                              type: "hour",
                              onChangePicker: (value) =>
                                onChangePicker("hour", value),
                              value: editStep?.hour?.toString() || "0",
                              disabled: editStep.day === -1,
                            },
                            {
                              type: "minutes",
                              onChangePicker: (value) =>
                                onChangePicker("minutes", value),
                              value: editStep?.minutes?.toString() || "0",
                              disabled: editStep.day === -1,
                            },
                          ]}
                        />
                      )}
                    </div>
                  );
                }
                case "ACTIVE": {
                  return (
                    <div>
                      <TemperatureDisplay
                        humidityEnabled={resData.loadSettingAck?.humidityEnabled}
                        unit={resData.loadSettingAck?.temperatureUnit as any}
                        dateFormat={resData.loadSettingAck?.dateFormat}
                        finishedAt={resData.runProgramAutoLogAck?.finishedAt}
                        state={activeLogData.state}
                        steps={steps}
                        temperature={
                          resData.runProgramTemperatureAck?.temperature || 0
                        }
                        humidity={
                          resData.runProgramTemperatureAck?.humidity || 0
                        }

                        runCurrentTime={
                          resData.runProgramProgressAck?.runCurrentTime
                        }
                        runTotalTime={
                          resData.runProgramProgressAck?.runTotalTime
                        }
                      />
                      <TemperatureChart
                        {...temperatureChartProps}


                        unit={resData.loadSettingAck?.temperatureUnit as any}

                        style={temperatureChartProps.styleTemperature}
                        records={temperatureChartProps.temperature}
                      />
                      {resData.loadSettingAck?.humidityEnabled && (
                        <TemperatureChart
                          {...temperatureChartProps}


                          unit={'RH'}
                          style={temperatureChartProps.styleHumidity}
                          records={temperatureChartProps.humidity}
                        />
                      )}

                    </div>
                  );
                }
                case "FINISHED": {
                  return (
                    <div
                      style={{
                        marginTop: 50,
                      }}
                    >
                      <TemperatureDisplay
                        humidityEnabled={resData.loadSettingAck?.humidityEnabled}
                        unit={resData.loadSettingAck?.temperatureUnit as any}
                        dateFormat={resData.loadSettingAck?.dateFormat}
                        style={{
                          marginLeft: 75,
                          marginBottom: 50,
                        }}
                        finishedAt={resData.runProgramAutoLogAck?.finishedAt}
                        state={activeLogData.state}
                        steps={steps}
                        temperature={
                          resData.runProgramTemperatureAck?.temperature || 0
                        }
                        humidity={
                          resData.runProgramTemperatureAck?.humidity || 0
                        }
                        runCurrentTime={
                          resData.runProgramProgressAck?.runCurrentTime
                        }
                        runTotalTime={
                          resData.runProgramProgressAck?.runTotalTime
                        }
                      />
                      <TemperatureChart
                        {...temperatureChartProps}


                        unit={resData.loadSettingAck?.temperatureUnit as any}

                        style={temperatureChartProps.styleTemperature}
                        records={temperatureChartProps.temperature}

                      />


                      {resData.loadSettingAck?.humidityEnabled && (
                        <TemperatureChart
                          {...temperatureChartProps}

                          unit={'RH'}
                          style={temperatureChartProps.styleHumidity}
                          records={temperatureChartProps.humidity}
                        />
                      )}
                    </div>
                  );
                }
              }
            })()}

            {(() => {
              switch (activeLogData?.state) {
                case "FINISHED": {
                  return (
                    <div
                      style={{ position: 'relative' }}
                    >
                      <Button
                        options={{
                          text: "SAVE LOG",
                          class: "bg-buttonRunBgColor text-4xl px-8",
                          cb: () =>
                            setSaveLogModal((data) => ({
                              ...data,
                              onSave: (value: string) => {
                                resData.runProgramAutoLogAck?.id && saveUserLog(resData.runProgramAutoLogAck?.id, value)
                                setSaveLogModal((data) => ({ ...data, isOpen: false }));

                              },
                              isOpen: true,
                              value: programName,
                            })),
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <Button
                        options={{
                          text: "EXIT",
                          class: "bg-buttonRunBgColor text-4xl px-8",
                          cb: exitProgram,
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                          marginLeft: 44,
                        }}
                      />

                      <Button
                        options={{
                          text: "FULL GRAPH",
                          cb: () => {
                            navigate(`${getRouterPath('/record-chart')}?status=finished`)
                          },
                        }}
                        style={{
                          padding: "0px 20px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                          fontSize: 15,
                          height: 40,
                          position: 'absolute',
                          bottom: 0,
                          right: -200,
                        }}
                      />
                    </div>
                  );
                }

                case "ACTIVE": {
                  return (
                    <div
                      style={{
                        position: 'relative',
                      }}
                    >
                      <div />
                      <Button
                        options={{
                          text: "STOP",
                          class: "bg-buttonRunBgColor text-4xl px-8",
                          cb: () => {

                            setMessageModal({
                              isOpen: true,
                              buttons: [
                                {
                                  text: "YES",
                                  onAction: () => {
                                    setMessageModal({ ...messageModal, isOpen: false });
                                    stopProgram()
                                  },
                                  style: {
                                    backgroundColor: '#5ede4e',
                                  }
                                },
                                {
                                  text: "NO",
                                  onAction: () => {
                                    setMessageModal({ ...messageModal, isOpen: false });
                                  },
                                },
                              ],
                              title: `Confirm Stop Program\nAre you sure you want to stop the current fermentation program? `,
                            });

                          },
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />

                      <Button
                        options={{
                          text: "FULL GRAPH",
                          cb: () => {
                            navigate(`${getRouterPath('/record-chart')}?status=active`)
                          },
                        }}
                        style={{
                          padding: "0px 20px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                          fontSize: 15,
                          height: 40,
                          position: 'absolute',
                          left: 340,
                          bottom: 0,
                        }}
                      />
                    </div>
                  );
                }
                case "DRAFT": {
                  return (
                    <Button
                      options={{
                        text: "START",
                        class: "bg-buttonRunBgColor text-4xl px-8",
                        cb: () => {
                          if (isZeroTimeStep) {
                            selectZeroTimeStepIfExists();
                            return;
                          }
                          if (!!resData.activeLogAck?.draftProgram) {
                            dataStore.setNav({ title: 'Saving Program' })
                            setSaveProgramModal((data) => ({
                              ...data,
                              title: "Save program as:",
                              value: programName,
                              isOpen: true,
                              onSave: async (value) => {

                                const isSave = await saveProgram(value)
                                if (isSave === 'YES') {
                                  runProgram(500)
                                  setSaveProgramModal((data) => ({
                                    ...data,
                                    isOpen: false,
                                  }));
                                }


                              },
                            }));
                          } else {
                            runProgram();
                          }
                        },
                      }}
                      style={{
                        padding: "0px 40px",
                        boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                        opacity: isZeroTimeStep ? 0.5 : 1,
                        fontSize: '36px'
                      }}
                    />
                  );
                }

                case "EDITING": {
                  return (
                    <div>
                      <Button
                        options={{
                          text: "CANCEL",
                          class: "bg-buttonRunBgColor text-4xl px-8",
                          cb: cancelEditProgram,
                        }}
                        type={"timeout"}
                        defaultTimeout={600}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <Button
                        options={{
                          text: "SAVE CHANGES",
                          class: "bg-buttonRunBgColor text-4xl px-8",
                          cb: () => {
                            if (isZeroTimeStep) {
                              selectZeroTimeStepIfExists();
                              return;
                            }

                            if (!!resData.activeLogAck?.draftProgram) {
                              setSaveProgramModal((data) => ({
                                ...data,
                                title: "Save changes as:",
                                value: programName,
                                isOpen: true,
                                onSave: async (value) => {
                                  const isSave = await saveProgram(value);
                                  if (isSave === 'YES') {
                                    setTimeout(() => {
                                      runProgram();
                                      setSaveProgramModal((data) => ({
                                        ...data,
                                        isOpen: false,
                                      }));
                                      cancelEditProgram()
                                    }, 500)

                                  }
                                },
                              }));
                            } else {
                              cancelEditProgram()
                            }
                          },
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                          marginLeft: 44,
                          opacity: isZeroTimeStep ? 0.5 : 1,
                        }}
                      />
                    </div>
                  );
                }

                default: {
                  return <div />;
                }
              }
            })()}
          </div>
        </div>

        {saveLogModal.isOpen && <InputModal {...saveLogModal} />}
        {saveProgramModal.isOpen && <InputModal {...saveProgramModal} />}
      </div>

      <MessageModal {...messageModal} />
    </div>
  );
}
export default observer(QuickStart);
